import { Box, Typography } from '@mui/material';
import { Preservation_Method_Enum } from '@kheops/graphql';
import { useTranslation } from 'react-i18next';

export interface ProductPreservationMethodProps {
  preservationMethod?: Preservation_Method_Enum | null;
}

export default function ProductPreservationMethod({ preservationMethod }: ProductPreservationMethodProps): React.JSX.Element {
  const { t } = useTranslation(['common', 'products']);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography variant="titleSmall">{t('products:buyer_preservation_method')}</Typography>
      <Typography variant="bodyMedium">
        {
          !preservationMethod
            ? t('common:not_filled')
            : t(`products:preservation_method_${preservationMethod.toLowerCase()}`)
        }
      </Typography>
    </Box>
  );
}
